import React from 'react';
import ReactNumberFormat from 'react-number-format';


interface INumberFormatProps {
    amount: number
    decimalScale?: number
    prefix?: string
    suffix?: string
}

let NumberFormat = ({ amount, prefix, suffix, decimalScale, ...rest }: INumberFormatProps) => {
    return (
        <ReactNumberFormat
            value={amount}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={decimalScale ? decimalScale : 2}
            fixedDecimalScale={true}
            prefix={prefix ? `${prefix} ` : ''}
            suffix={suffix ? ` ${suffix}` : ''}
            {...rest}
        />
    );
}

export default NumberFormat;